import classNames from 'classnames';
import React from 'react';
import { AddStrongIcon } from 'src/monet/icons';
import { NewJourneyType } from '../../interfaces/journey/new-journey-type.enum';
import { ImageWithHoverableIcon } from '../image-with-hoverable-icon';

export type CreateJourneyTypes = 'wizard' | 'blank' | 'internal-template' | 'external-template';
export interface CreateJourneyCardProps {
  type: NewJourneyType;
  imageSrc: string;
  text: string;
  subText: string;
  onClick?: () => void;
}

export const CreateJourneyCard = ({ type, imageSrc, text, subText, onClick }: CreateJourneyCardProps) => {
  const getHoverIconByType = () => {
    let IconComponent = ({ className }: { className?: string }) => (
      <svg
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='transparent'
        xmlns='http://www.w3.org/2000/svg'
        className={classNames('transform-gpu', className)}
      >
        <path
          d='M10 4.75L2.75 2.75V15.25L10 17.25'
          stroke='white'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path d='M10 5V17' stroke='white' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        <path
          d='M10 4.75L17.25 2.75V15.25L10 17.25'
          stroke='white'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    );

    if (type === NewJourneyType.WIZARD) {
      IconComponent = ({ className }: { className?: string }) => (
        <svg
          width='20'
          height='20'
          viewBox='0 0 20 20'
          fill='transparent'
          xmlns='http://www.w3.org/2000/svg'
          className={classNames('transform-gpu', className)}
        >
          <path
            d='M13 2.75C13 5.51142 11.5114 8 8.75 8C11.5114 8 13 10.4886 13 13.25C13 10.4886 14.4886 8 17.25 8C14.4886 8 13 5.51142 13 2.75Z'
            stroke='white'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M6 10.75C6 12.4069 4.40685 14 2.75 14C4.40685 14 6 15.5931 6 17.25C6 15.5931 7.59315 14 9.25 14C7.59315 14 6 12.4069 6 10.75Z'
            stroke='white'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      );
    } else if (type === NewJourneyType.SCRATCH) {
      IconComponent = ({ className }: { className?: string }) => (
        <AddStrongIcon className={classNames('transform-gpu', className)} />
      );
    }

    return IconComponent;
  };

  return (
    <div
      className='relative flex gap-4 cursor-pointer rounded shrink-0 group items-center bg-bedrock-white transition-colors hover:bg-bedrock-light-gray'
      onClick={onClick}
    >
      <ImageWithHoverableIcon
        src={imageSrc}
        hideImageOnHover={false}
        className='w-10 h-10 m-1 rounded bg-bedrock-white transition-colors group-hover:bg-bedrock-light-gray'
        iconContainerClassName='items-center w-10 h-10 ml-1 pointer-events-none'
        iconWrapperClassName='rounded'
        renderIcon={(animationClassName) => {
          const Component = getHoverIconByType();
          return <Component className={classNames('w-5 h-full m-auto text-bedrock-white', animationClassName)} />;
        }}
      />
      <div className='flex flex-col pr-1 mr-4'>
        <span className='text-bedrock-p-strong text-bedrock-black'>{text}</span>
        <p className='text-bedrock-p-small text-bedrock-dark-gray'>{subText}</p>
      </div>
    </div>
  );
};
